import React, { useEffect, useState } from "react";
import CountUp, { useCountUp } from 'react-countup';
import DefaultLink from "../../components/DefaultLink";
import { useModal } from "../../contexts/ModalContext";

const parseStatValue = (value = "") => {
  const number = value.match(/[\d.]+/)?.[0] || "0";
  const symbol = value.replace(/[\d.]+/g, "").trim();
  return { number, symbol };
};

export default function DynamicPageCounter({ countData, data }) {

  const { openQueryModal } = useModal();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, [])

  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 3000,
  });

  const stat1 = parseStatValue(data?.stat_one_number);
  const stat2 = parseStatValue(data?.stat_two_number);
  const stat3 = parseStatValue(data?.stat_three_number);

  if (!Object.keys(stat1)?.length) return null;

  return (
    <>
      <section className="physical-tool-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="physical-tool-box">
                <div className="row align-items-center">
                  <div className="col-lg-4 col-md-9 text-center text-md-start">
                    <span>{countData?.title}</span>
                    <p>{countData?.para}</p>
                    <DefaultLink text={countData?.btn} onClick={openQueryModal} />
                  </div>

                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <div className="physical-count">
                          <span>
                            {isClient ?
                              <CountUp end={stat1?.number} enableScrollSpy /> :
                              <span>{stat1?.number}</span>
                            }
                            {stat1?.symbol}
                          </span>
                          <p>{data?.stat_one_description}</p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <div className="physical-count">
                          <span>
                            {isClient ?
                              <CountUp end={stat2?.number} enableScrollSpy /> :
                              <span>{stat2?.number}</span>
                            }
                            {stat2?.symbol}
                          </span>
                          <p>{data?.stat_two_description}</p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <div className="physical-count">
                          <span>
                            {isClient ?
                              <CountUp end={stat3?.number} enableScrollSpy /> :
                              <span>{stat3?.number}</span>
                            }
                            {stat3?.symbol}
                          </span>
                          <p>{data?.stat_three_description}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}